import { render, staticRenderFns } from "./ViewUTMDetail.vue?vue&type=template&id=30544641&scoped=true"
import script from "./ViewUTMDetail.vue?vue&type=script&lang=js"
export * from "./ViewUTMDetail.vue?vue&type=script&lang=js"
import style0 from "./ViewUTMDetail.vue?vue&type=style&index=0&id=30544641&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "30544641",
  null
  
)

export default component.exports